// extracted by mini-css-extract-plugin
module.exports = {"handbook":"styles-module--handbook--LtWsY","wrapper":"styles-module--wrapper--2lg7s","gagb":"styles-module--gagb--2otaP","date":"styles-module--date--1Fgld"};